import React, { useEffect, useState, useContext } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import BrandModalContent from "./BrandModalContent";
import "./RewardsLevels.css";
import BrandsFeaturesCarousel from "./BrandsFeaturesCarousel";
import { BrandsContext } from "../../context/BrandsContext";
import { MilestonesContext } from "../../context/MilestonesContext";
import { MilestoneBenefitsContext } from "../../context/MilestoneBenefitsContext";

const RewardsLevels = ({ fluid = false, customer_milestones = [] }) => {
  const [selectedLevel, setSelectedLevel] = useState();
  const [selectedBrand, setSelectedBrand] = useState();
  const [showCarousel, setShowCarousel] = useState(false);
  const [showAllCarousel, setShowAllCarousel] = useState(false);
  const { brands, getBrands } = useContext(BrandsContext);
  const { milestones, getMilestones } = useContext(MilestonesContext);
  const { milestone_benefits, getMilestoneBenefits } = useContext(MilestoneBenefitsContext);

  useEffect(() => {
    if (!brands) {
      getBrands();
    }
    if (!milestones) {
      getMilestones();
    }
    if (!milestone_benefits) {
      getMilestoneBenefits();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasAchievedMilestone = (level) => {
    if (Array.isArray(customer_milestones)) {
      const hasAchievedMilestone = customer_milestones.find(
        ({ milestone_id }) => milestone_id === level.milestone_id
      );
      return hasAchievedMilestone !== undefined;
    }
    return false;
  };

  const hasMilestoneBenefits = (milestoneId) => {
    if (!milestone_benefits || !Array.isArray(milestone_benefits)) {
      return false;
    }
    return milestone_benefits.some(
      (mb) => mb.milestone_id === milestoneId
    );
  };

  const handleLevel = (brand, level) => {
    const has_achieved = hasAchievedMilestone(level);
    setSelectedLevel(level.milestone_id);
    setSelectedBrand(brand);
    if (!has_achieved) setShowAllCarousel(true);
    else setShowCarousel(true);
  };

  useEffect(() => {
    if (showCarousel) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [showCarousel]);

  const isSmallDevice = useWindowSize(768);

  const renderStars = (amount, has_achieved) => {
    let current = 0;
    const stars = [];

    do {
      stars.push(
        <div
          key={`${current}-${amount}`}
          className={`${isSmallDevice ? "star__small " : "item__star"} ${has_achieved ? "achieved" : ""}`}
          style={{
            width: isSmallDevice ? 30 : 50,
            height: isSmallDevice ? 30 : 50,
          }}
        />
      );

      current++;
    } while (current < amount);

    return stars;
  };

  const renderLevels = () => {
    if (!milestones) return null;
    
    const sortedMilestones = [...milestones].sort((a, b) => (a.order || 0) - (b.order || 0));
    
    const levelsWithBenefits = sortedMilestones.filter((level) => 
      hasMilestoneBenefits(level.milestone_id)
    );
    
    return levelsWithBenefits.map((level, index) => {
      const has_achieved = hasAchievedMilestone(level);
      return (
        <div
          key={level.milestone_id}
          className={`accordion-item shadow mb-3 ${fluid ? "fluid" : ""}`}
        >
          <h2 className={`accordion-header`}>
            <button
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${level.milestone_id}`}
              aria-expanded={fluid ? false : index === 0}
              aria-controls={`collapse-${level.milestone_id}`}
              className={`accordion-button d-flex justify-content-start align-items-center ${has_achieved ? "achieved" : ""}`}
            >
              <h2 className={`bold item__title pe-2`}>
                {level.name && level.name.toLowerCase().includes("mes") 
                  ? level.name 
                  : `NIVEL ${level.milestone_id} ${level.name}`}{" "}
              </h2>
              <div className={`w-max-content ms-auto d-flex ${has_achieved ? "text-rewards-gradient" : ""}`}>
                {renderStars(level.milestone_id, has_achieved)}
              </div>
            </button>
          </h2>
          <div
            id={`collapse-${level.milestone_id}`}
            className={`accordion-collapse collapse ${
              !fluid && index === 0 ? "show" : ""
            }`}
            data-bs-parent="#rewardsLevelsAccordion"
          >
            <div className="accordion-body">
              <p>
                {level.name && level.name.toLowerCase().includes("mes") 
                  ? <span>{level.description || ""}</span>
                  : <>{level.name}: <span>{level.description || ""}</span></>
                }
              </p>
              {hasMilestoneBenefits(level.milestone_id) && (
                <p className="text-dark">Haz click en el logo de cada marca para ver tus beneficios.</p>
              )}
              <div className="d-flex w-100 flex-wrap">
                {brands && brands
                  .filter((brand) => {
                    if (!milestone_benefits || !Array.isArray(milestone_benefits)) {
                      return false;
                    }
                    return milestone_benefits.some(
                      (mb) => mb.brand_id === brand.brand_id && mb.milestone_id === level.milestone_id
                    );
                  })
                  .map((brand) => (
                    <div
                      key={brand.brand_id}
                      className={`d-flex bg-white justify-content-center align-items-center mx-1 ${!has_achieved ? "disabled" : "cursor-pointer"}`}
                      onClick={() => handleLevel(brand, level)}
                      style={{
                        borderRadius: "50%",
                        width: isSmallDevice ? 30 : 50,
                        height: isSmallDevice ? 30 : 50,
                      }}
                    >
                      <img
                        alt="brand-icon"
                        width={"100%"}
                        height={"auto"}
                        src={brand.file?.src || brand.logo}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      );
    });
  };
  return (
    <div
      id="scrollspyLevels"
      className={`${
        fluid ? "container-fluid px-3 py-0" : "container"
      } rewards-levels`}
    >
      {!fluid && (
        <div className="row pt-md-5 pt-3">
          <div className="col-12 col-md-5 p-0 text-capitalize">
            <h3 className="levels-title mb-0">
              Descubre Nuestros Niveles de Recompensa
            </h3>
          </div>
          <div className="col-12 col-md-5 ms-auto p-0">
            <p className="levels-description mb-0">
              A medida que avanzas en nuestro programa, desbloquearás beneficios
              exclusivos y recompensas. ¡Tu esfuerzo será premiado en cada paso
              del camino!
            </p>
          </div>
        </div>
      )}

      <div className={`row ${fluid ? "" : "mt-5"}`}>
        <div className="col-12 col-md-6 px-0">
          {fluid && (
            <p className="levels-description">
              A medida que avanzas en nuestro programa, desbloquearás beneficios
              exclusivos y recompensas. ¡Tu esfuerzo será premiado en cada paso
              del camino!
            </p>
          )}
          <div className="accordion bg-white" id="rewardsLevelsAccordion">
            {renderLevels()}
          </div>
        </div>
        <div className="col-12 col-md-6 px-0">
          <div className="row justify-content-center">
            <img
              alt="tbm team"
              src="/img/rewards-image.png"
              className={`img-levels ${!fluid ? "ms-auto" : "m-auto"}`}
              style={{ width: !fluid ? "420px" : "90%" }}
            />
            {!fluid && (
              <p
                className="ms-auto mt-3 levels__image-desc"
                style={{ width: "420px" }}
              >
                TBM Rewards esta diseñado para celebrar tu dedicación y
                motivarte en cada paso de tu camino fitness, tanto en nuestros
                estudios presenciales en Monterrey y Tijuana como en nuestra
                comunidad en línea.
              </p>
            )}
          </div>
        </div>
      </div>
      {showAllCarousel && selectedBrand && (
        <BrandsFeaturesCarousel
          selectedBrand={selectedBrand}
          showCarousel={showAllCarousel}
          setShowCarousel={setShowAllCarousel}
          brands={brands}
        />
      )}
      {showCarousel && selectedBrand && selectedLevel && (
        <>
          <div
            className="rewards-brands__features" // Option 1 bg-rewards-gradient
            style={{
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              borderRadius: "8px",
              zIndex: 1000,
            }}
          >
            <section className="carousel__brands-features">
              <div className="brands-features__viewport">
                <div id="rewardsModal" className="brands-features__container">
                  <BrandModalContent
                    brand={selectedBrand}
                    level={selectedLevel}
                    handleClose={() => setShowCarousel(false)}
                  />
                </div>
              </div>
            </section>
          </div>
          <div className="rewards-brands__backdrop"></div>
        </>
      )}
    </div>
  );
};

export default RewardsLevels;
